
let stringUtils = {}


//****************************** SOFT CONVERTING

//****************************** Camel To

stringUtils.camelToSeparator = function (str, separator) {
    str = str.replace(/([A-Z]+)([A-Z][a-z])/g, `$1${separator}$2`)
    return str.replace(/([a-z\d])([A-Z])/g, `$1${separator}$2`).toLowerCase()
}

stringUtils.camelToSnake = function (str) {
    return stringUtils.camelToSeparator(str, "_")
}


stringUtils.camelToSpace = function (str) {
    return stringUtils.camelToSeparator(str, " ")
}


stringUtils.camelToDash = function (str) {
    return stringUtils.camelToSeparator(str, "-")
}


stringUtils.camelToPascale = function (str) {
    return stringUtils.upperFirstLetter(str)
}






//****************************** Pascale to

stringUtils.pascaleToSnake = function (str) {
    str = stringUtils.pascaleToCamel(str)
    return stringUtils.camelToSeparator(str, "_")
}


stringUtils.pascaleToSpace = function (str) {
    str = stringUtils.pascaleToCamel(str)
    return stringUtils.camelToSeparator(str, " ")
}


stringUtils.pascaleToDash = function (str) {
    str = stringUtils.pascaleToCamel(str)
    return stringUtils.camelToSeparator(str, "-")
}


stringUtils.pascaleToCamel = function (str) {
    return stringUtils.lowerFirstLetter(str)
}





//****************************** Space to

stringUtils.spaceToSnake = function (str) {
    return stringUtils.separatorToAnotherSeparator(str.toLowerCase(), "\\s+", "_")
}


stringUtils.spaceToDash = function (str) {
    return stringUtils.separatorToAnotherSeparator(str.toLowerCase(), "\\s+", "-")
}


stringUtils.spaceToCamel = function (str) {
    return stringUtils.separatorToCamel(str.toLowerCase(), "\\s")
}


stringUtils.spaceToPascale = function (str) {
    return stringUtils.upperFirstLetter(stringUtils.spaceToCamel(str))
}



//****************************** Dash to

stringUtils.dashToSnake = function (str) {
    return stringUtils.separatorToAnotherSeparator(str, "-", "_")
}


stringUtils.dashToSpace = function (str) {
    return stringUtils.separatorToAnotherSeparator(str, "-", " ")
}


stringUtils.dashToCamel = function (str) {
    return stringUtils.separatorToCamel(str, "-")
}




stringUtils.dashToPascale = function (str) {
    return stringUtils.upperFirstLetter(stringUtils.separatorToCamel(str, "-"))
}




//****************************** Snake to

stringUtils.snakeToDash = function (str) {
    return stringUtils.separatorToAnotherSeparator(str, "_", "-")
}


stringUtils.snakeToSpace = function (str) {
    return stringUtils.separatorToAnotherSeparator(str, "_", " ")
}


stringUtils.snakeToCamel = function (str) {
    return stringUtils.separatorToCamel(str, "_")
}


stringUtils.snakeToPascale = function (str) {
    return stringUtils.upperFirstLetter(stringUtils.separatorToCamel(str, "_"))
}



//****************************** Utils


stringUtils.separatorToCamel = function (str, separator) {
    let regex = new RegExp(`${separator}+([^${separator}])`, "g")

    return str.replace(regex, function (fullMatch, pattern1) {
        return pattern1.toUpperCase()
    }).replace(/\s/g, "")
}


stringUtils.separatorToAnotherSeparator = function (str, initialSeparator, targetSeparator) {
    let regex = new RegExp(initialSeparator, "g")
    return str.replace(regex, targetSeparator)
}


stringUtils.upperFirstLetter = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
}


stringUtils.lowerFirstLetter = function (string) {
    return string.charAt(0).toLowerCase() + string.slice(1)
}






//****************************** HARD CONVERTING

stringUtils.dasherize = function (string) {
    return string
        .trim()
        .replace(/([a-z\d])([A-Z]+)/g, "$1-$2")
        .replace(/[_\s]+/g, "-")
        .toLowerCase()
}


stringUtils.camelize = function (string) {
    let str = string.trim().replace(/[-_\s]+(.)?/g, function (match, c) {
        return c ? c.toUpperCase() : ""
    })

    return stringUtils.lowerFirstLetter(str)
}


stringUtils.pascalize = function (string) {
    return stringUtils.upperFirstLetter(stringUtils.camelize(string))
}


stringUtils.snakerize = function (string) {
    return string
        .trim()
        .replace(/([a-z\d])([A-Z]+)/g, "$1_$2")
        .replace(/[-\s]+/g, "_")
        .toLowerCase()
}



stringUtils.removeAccents = function (string) {
    return string
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
}


stringUtils.normalizeFamilyName = function (name) {

    const particles = [
        "an", "auf", "von", "dem", "den", "der", "zu", "zur",
        "de", "del", "las", "los", "y",
        "a", "d'", "da", "das", "do", "dos"
    ]

    return name
        .trim()
        .toLowerCase()
        .split(/\s+/)
        .map(word => {
            return word
                .split("-")
                .map(wordPart => {
                    if (particles.includes(wordPart)) {
                        return wordPart
                    } else {
                        return stringUtils.upperFirstLetter(wordPart)
                    }
                })
                .join("-")
        })
        .join(" ")

}



stringUtils.regexp = {
    latin:               /^([A-Za-z0-9\-_À-ÖØ-öø-ÿ\s]*)$/,
    latinText:           /^([A-Za-z0-9\-_À-ÖØ-öø-ÿ\s'!,()]*)$/,
    classicVariableName: /^([a-zA-Z_$][0-9a-zA-Z_$]*)$/,
    latinVariableName:   /^([A-Za-zÀ-ÖØ-öø-ÿ_$][0-9A-Za-zÀ-ÖØ-öø-ÿ_$]*)$/
}

stringUtils.regexpPortions = {
    latinVariableName: "[A-Za-zÀ-ÖØ-öø-ÿ_$][0-9A-Za-zÀ-ÖØ-öø-ÿ_$]*"
}




//****************************** ESCAPING



// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
stringUtils.escapeForRegExp = function (string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}




//****************************** REPLACE ALL


stringUtils.replaceAll = function (string, search, replacement) {
    return string.replace(new RegExp(search, "g"), replacement)
}


//****************************** INTERPOLATION


stringUtils.interpolate = function (string, data) {
    data = data || {} //don't use ES6 here (Planot PEPS)
    for (let key in data) {
        string = stringUtils.replaceAll(string, `{{${key}}}`, data[key])
    }
    return string
}


//****************************** LEVENSHTEIN DISTANCE

/*eslint-disable complexity */
stringUtils.distance = function (a, b) {
    if (a.length === 0) {
        return b.length
    }

    if (b.length === 0) {
        return a.length
    }

    let matrix = []

    // increment along the first column of each row
    let i
    for (i = 0; i <= b.length; i++) {
        matrix[i] = [i]
    }

    // increment each column in the first row
    let j
    for (j = 0; j <= a.length; j++) {
        matrix[0][j] = j
    }

    // Fill in the rest of the matrix
    for (i = 1; i <= b.length; i++) {
        for (j = 1; j <= a.length; j++) {
            if (b.charAt(i - 1) === a.charAt(j - 1)) {
                matrix[i][j] = matrix[i - 1][j - 1]
            } else {
                matrix[i][j] = Math.min(
                    matrix[i - 1][j - 1] + 1, // substitution
                    Math.min(
                        matrix[i][j - 1] + 1, // insertion
                        matrix[i - 1][j] + 1
                    )
                ) // deletion
            }
        }
    }

    return matrix[b.length][a.length]
}
/*eslint-enable complexity */






export default stringUtils
